export default __webpack_public_path__ + "static/media/carousel3.d2d99637.jpg";